export const CTA_TEXT = `לבדיקת דייר בחינם`;
export const CTA_OPEN_TITLE = `נעים להכיר :)`;
export const DATA_BY_AREA_TITLE = `נתונים לפי אזור`;
